import {SliderNumberBox} from '@fantasmagames/slot/src/display/Slider/SliderNumberBox';
import {SnappingSlider} from '@fantasmagames/slot/src/display/Slider/SnappingSlider';

export class AutoplaySlider extends SnappingSlider {
	protected updateValue(value: number): void {
		this._currentValue = value;
		if (this._sliderBox) {
			if (value === 0) {
				this._sliderBox.updateNumber('-');
			} else {
				const sliderBoxValue = this._showAsCurrency ? this.currencyFormatter.formatCurrency(value, true) : value.toString();

				this._sliderBox.updateNumber(sliderBoxValue);
			}
		}

		if (this._onValueChangedCallback) {
			this._onValueChangedCallback.call(this, value);
		}
	}

	public set sliderNumberBox(box: SliderNumberBox) {
		this._sliderBox = box;
		this.updateValue(0);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/display/Slider/AutoplaySlider.ts